import React, { useState, useRef, useEffect } from 'react'
import './PullToRefreshBox.less'

const PULL_THRESHOLD = 50
const RESISTANCE = 0.2
const MAX_PULL_DISTANCE = 130

const PullToRefreshBox = ({ onRefresh, children, disabled = false }) => {
  const [startY, setStartY] = useState(0)
  const [currentTranslateY, setCurrentTranslateY] = useState(0)
  const [isRefreshing, setIsRefreshing] = useState(false)
  const containerRef = useRef(null)
  const isMounted = useRef(true)

  const needsTransition = startY === 0 && currentTranslateY > 0

  useEffect(() => {
    isMounted.current = true

    return () => isMounted.current = false
  }, [])
  
  useEffect(() => {
    if (!isRefreshing && isMounted.current) {
      setCurrentTranslateY(0)
    }
  }, [isRefreshing])

  const handleTouchStart = (e) => {
    if (disabled || isRefreshing) return
    
    if (containerRef.current && containerRef.current.scrollTop <= 1) {
      setStartY(e.touches[0].clientY)
    } else {
      setStartY(0)
    }
  }

  const handleTouchMove = (e) => {
    if (!startY || disabled || isRefreshing) return
    
    const currentY = e.touches[0].clientY
    const diff = currentY - startY

    if (diff > 0 && containerRef.current.scrollTop <= 1) {
      let newTranslate = diff * RESISTANCE
      if (newTranslate > MAX_PULL_DISTANCE) {
        newTranslate = MAX_PULL_DISTANCE + (newTranslate - MAX_PULL_DISTANCE) * 0.1 
      }
      setCurrentTranslateY(newTranslate)
    }
  }

  const handleTouchEnd = async () => {
    if (!startY || disabled || isRefreshing) return

    setStartY(0)
    if (currentTranslateY > PULL_THRESHOLD) {
      setIsRefreshing(true)
      setCurrentTranslateY(PULL_THRESHOLD)
      try {
        if (onRefresh) await onRefresh()
      }
      catch (error) { console.error('Error al realizar refresh', error) }
      finally {
        if (isMounted.current) {
          setIsRefreshing(false)
          setCurrentTranslateY(0)
        }
      }
    } else setCurrentTranslateY(0)
  }

  return (
    <div 
      className="pull-refresh-wrapper"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div 
        className="pull-loader-container"
        style={{ 
          height: PULL_THRESHOLD, 
          top: -PULL_THRESHOLD,
          transform: `translateY(${currentTranslateY}px)`
        }}
      >
        <div className={`pull-spinner ${isRefreshing ? 'spinning' : ''}`} style={{opacity: currentTranslateY > 10 ? 1 : 0}}>
           <span className="icon-arrow">↻</span>
        </div>
      </div>
      <div 
        ref={containerRef}
        className="pull-content"
        style={{ 
          transform: `translateY(${currentTranslateY}px)`,
          transition: needsTransition ? 'transform 0.3s cubic-bezier(0.1, 0.7, 0.1, 1)' : 'none' 
        }}
      >
        {children}
      </div>
    </div>
  )
}

export default PullToRefreshBox